import { UntypedFormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class ReactiveFormsFunctions {
  getChangedValues(form: UntypedFormGroup) {
    const dirtyValues = { object: {}, keyValues: [] };
    Object.keys(form.controls).forEach((key) => {
      const currentControl = form.controls[key];
      if (currentControl.dirty) {
        dirtyValues.object[key] = currentControl.value;
        dirtyValues.keyValues.push({
          key,
          value: currentControl.value,
        });
      }
    });
    return dirtyValues;
  }
}
